import { getOptionalAnalyticsAuthToken } from './analyticsIdentity';

export type GeneratedPlanningReport = {
  report: string;
  metadata?: Record<string, unknown>;
};

/**
 * Calls /api/generate-report with the signed-in user's token. The route needs
 * a CityScope account, so a missing or expired sign-in becomes a clear message.
 */
export async function requestPlanningReport(application: unknown): Promise<GeneratedPlanningReport> {
  const token = await getOptionalAnalyticsAuthToken();
  const response = await fetch('/api/generate-report', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ application }),
  });
  let data: { report?: unknown; metadata?: Record<string, unknown>; error?: unknown } | null = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (response.status === 401) {
    throw new Error('Sign in to your CityScope account to generate a report.');
  }
  if (!response.ok || !data || data.error || typeof data.report !== 'string') {
    throw new Error(typeof data?.error === 'string' ? data.error : `HTTP error! status: ${response.status}`);
  }
  return { report: data.report, metadata: data.metadata };
}
